/** @jsx jsx */
import { jsx, Styled } from 'theme-ui';
import { rgba } from 'polished';
import { colors } from '../../gatsby-plugin-theme-ui';

export const Container = (props) => (
  <div
    sx={{
      position: 'relative',
      zIndex: 100,
      px: ['1.4rem', '2.8rem', '6.4rem'],
      pt: ['8rem', null, '9.6rem'],
      pb: ['2.8rem'],
      minWidth: '375px',
      maxWidth: ['50%', null, '550px'],
      width: '100%',
      height: [null, null, '530px'],
      bg: rgba(colors.PrimaryDarkBlue, 0.75),
    }}
    {...props}
  />
);

export const IntroText = (props) => (
  <Styled.h1
    sx={{
      mb: '2.8rem',
      minHeight: ['13.6rem', null, '18rem'],
    }}
    {...props}
  />
);
